// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__1wLSR","content":"Dashboard_content__1JZxu","sidebar-wrapper":"Dashboard_sidebar-wrapper__3Y6Jw","selected":"Dashboard_selected__3_KBJ"};